export default __webpack_public_path__ + "static/media/google.cc9807ef.svg";